import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { UiModule } from '@ov-suite/ui';
import { LiveFeedListComponent } from './list/live-feed-list.component';
import { LiveFeedRoutes } from './live-feed-routing';
import { ExitEntryEventService } from '../../services/exit-entry-event/exit-entry-event.service';
import { TableTopNavMenuModule } from '../../../../../ceramic-portal-web/src/app/components/table-top-nav-menu/table-top-nav-menu.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(LiveFeedRoutes),
    FormsModule,
    UiModule,
    TableTopNavMenuModule,
  ],
  declarations: [LiveFeedListComponent],
  providers: [ExitEntryEventService],
})
export class LiveFeedModule { }
